import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import galleries from './galleries'
import watermarks from './watermarks'
/**
* @see \App\Http\Controllers\Studio\DashboardController::dashboard
* @see app/Http/Controllers/Studio/DashboardController.php:20
* @route '/studio/nastenka'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/studio/nastenka',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Studio\DashboardController::dashboard
* @see app/Http/Controllers/Studio/DashboardController.php:20
* @route '/studio/nastenka'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\DashboardController::dashboard
* @see app/Http/Controllers/Studio/DashboardController.php:20
* @route '/studio/nastenka'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\DashboardController::dashboard
* @see app/Http/Controllers/Studio/DashboardController.php:20
* @route '/studio/nastenka'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Studio\DashboardController::dashboard
* @see app/Http/Controllers/Studio/DashboardController.php:20
* @route '/studio/nastenka'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\DashboardController::dashboard
* @see app/Http/Controllers/Studio/DashboardController.php:20
* @route '/studio/nastenka'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\DashboardController::dashboard
* @see app/Http/Controllers/Studio/DashboardController.php:20
* @route '/studio/nastenka'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

const studio = {
    dashboard: Object.assign(dashboard, dashboard),
    galleries: Object.assign(galleries, galleries),
    watermarks: Object.assign(watermarks, watermarks),
}

export default studio